import type { ReactNode } from 'react';
import { Navigate } from 'react-router-dom';
import { getStoredUser, getStoredMirror } from '../hooks/useAuth';
import { VACANCY_REGISTRY, MEETING_VACANCIES, type VacancyId } from '../config/vacancies';

export function RequireAuth({ children }: { children: ReactNode }) {
  if (!getStoredUser()) return <Navigate to="/" replace />;
  return <>{children}</>;
}

export function RequireVacancy({ vacancy, children }: { vacancy: VacancyId; children: ReactNode }) {
  const user = getStoredUser();
  const mirror = getStoredMirror();
  if (!user) return <Navigate to="/" replace />;
  if (!mirror.vacancies.includes(vacancy)) return <Navigate to="/vacancy" replace />;
  // Набор закрыт: карточка на /vacancy некликабельна, прямой URL тоже не должен пускать.
  if (VACANCY_REGISTRY[vacancy]?.disabled) return <Navigate to="/vacancy" replace />;
  return <>{children}</>;
}

/**
 * Страница /meeting доступна не всем. Без этого guard'а «Менеджер оценки качества»
 * (у него meetingRequest: false, кнопки нет) всё равно откроет заявку по прямому URL,
 * и она прилетит менеджеру через бота вперемешку с настоящими.
 */
export function RequireMeetingAccess({ children }: { children: ReactNode }) {
  const user = getStoredUser();
  const mirror = getStoredMirror();
  if (!user) return <Navigate to="/" replace />;
  if (!mirror.vacancies.some((v) => MEETING_VACANCIES.includes(v))) {
    return <Navigate to="/vacancy" replace />;
  }
  return <>{children}</>;
}
